// The card details modal opens a member's cards (`uuid`) and Post sequence entries (`ICard`,
// which only carry the library card's `card_uuid`).
export const getCardUuid = (card: { uuid?: string; card_uuid?: string }): string | undefined =>
  card.uuid ?? card.card_uuid;
